import React from 'react';
import { IconLookup } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCcAmex, faCcDiscover, faCcMastercard, faCcPaypal, faCcVisa } from '@fortawesome/free-brands-svg-icons';

/**
 * The card marks. The legacy footer draws them as one `payment-icons.png` sprite; these
 * are the same five, in the order that image shows them.
 *
 * Drawn from the icon set rather than the brand's own SVGs, which is what both existing
 * brands' footers do (TopMags' came off a `payment-icons.png` sprite and DiscountMags'
 * off its own images). Keeping to one source is what stops a sixth brand needing a sixth
 * set of assets.
 *
 * Not in `shared/Layouts/Full/Footer` beside FooterMenu — see the note on MagSpot's, which
 * is this component in a different order, because that is the order MagSpot's own image
 * showed.
 */
export default function AcceptedPaymentMethods() {
  const paymentMethods: { icon: IconLookup }[] = [
    { icon: faCcPaypal },
    { icon: faCcVisa },
    { icon: faCcMastercard },
    { icon: faCcAmex },
    { icon: faCcDiscover },
  ];

  return (
    <ul className="m-0 flex list-none justify-center gap-2 p-0">
      {paymentMethods.map(({ icon }, index) => (
        <li key={index}>
          <FontAwesomeIcon icon={icon} size="2x" className="text-slate-500" />
        </li>
      ))}
    </ul>
  );
}
